import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.eggShell,
  fontColor: colors.smoke,
  textColorDark: colors.smoke,
  textColorLight: colors.white
};
export default promoBanner;